import { API_PREFIX } from "./api.constants";


export const AUDIT_ENDPOINTS = {
  LOGS: `${API_PREFIX}/audit-logs/`,
  EXPORT: `${API_PREFIX}/audit-logs/export`,
};

export const IMPERSONATION_ENDPOINTS = {
  LOGIN_AS: (userId: number | string) => `${API_PREFIX}/impersonation/${userId}/login-as`,
  RETURN: `${API_PREFIX}/impersonation/return-to-account`,
};